(ns minorodata.vcs.events
  (:require [ajax.url :as url]
            [applied-science.js-interop :as js-interop]
            [minorodata.app.api-config :refer [AUTH_API_HOST]]
            [minorodata.app.handlers :refer [reg-cofx reg-fx]]
            [minorodata.app.utils :as utils]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]))


(re-frame/reg-event-fx
 :vcs.events/init
 (fn [_ _]
   {:async-flow
    {:first-dispatch [:vcs.api/get-config]
     :rules          [{:when     :seen?
                       :events   :vcs.api/get-config-success
                       :dispatch [:vcs.api/get-repos]
                       :halt?    true}]}}))
